module.exports = __webpack_public_path__ + "img/file-manager-2.1c9f15e1.png";